import styled from 'styled-components';
const StyledServiceItemContainer = styled.div``;
export default StyledServiceItemContainer;
